import { AspectKeyGlobal } from '../traitKey/AspectKeyGlobal';
export class AspectKeyRegional extends AspectKeyGlobal {
    get keyTraits() {
        return this.aspect.traits;
    }
}
